import { render } from "./GenericDialog.vue?vue&type=template&id=1b8c76a5&scoped=true&ts=true"
import script from "./GenericDialog.ts?vue&type=script&lang=ts"
export * from "./GenericDialog.ts?vue&type=script&lang=ts"

import "./GenericDialog.vue?vue&type=style&index=0&id=1b8c76a5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8c76a5"]])

export default __exports__